import { useState } from "react";
import { Col } from "react-bootstrap";
import { getCheckUsername } from "../../../../api";
import { useLanguageContext, useThemeContext } from "../../../../context";
import { Button, CheckBox, TextField } from "../../../common";
import { hashSync } from "bcryptjs";
import { HASH_SALT } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import Icon from "../../../../assets/icons";

const Step2 = ({ toggleStep, handleSave }) => {
  const { I18n } = useLanguageContext();
  const { theme } = useThemeContext();
  let navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [viewConfirmPassword, setViewConfirmPassword] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [pin, setPin] = useState();
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggleCheckBox = () => setIsChecked((x) => !x);

  const handleBack = () => toggleStep("1");

  const onChange = (label, value) => {
    if (label === I18n.enter_username) {
      setUsername(value);
    } else if (label === I18n.create_password) {
      setPassword(value);
    } else if (label == I18n.create_pin_code) {
      setPin(value);
    }

    setErrors({});
  };

  const handleNext = () => {
    if (!password) {
      setErrors({
        password: I18n.required_password,
      });
      return;
    }

    let paramsForApi = {
      username,
    };

    setIsLoading(true);

    getCheckUsername(paramsForApi)
      .then((res) => {
        let hash = hashSync(pin, HASH_SALT);

        let details = {
          username,
          password,
          pin: hash,
        };

        handleSave(details);
      })
      .catch((err) => {
        setErrors({ username: I18n.username_already_exists });
      })
      .finally(() => setIsLoading(false));
  };

  const handleEnterPress = (event) => {
    if (
      event.key === "Enter" &&
      username &&
      password &&
      pin &&
      !Object.keys(errors).length
    ) {
      handleNext();
    }
  };

  return (
    <>
      <Col md={5} onKeyDown={handleEnterPress}>
        <div className="loginFormBox">
          <div className="signupTextBox">
            <h1
              className="fontSize24 fontWeight700 marBot10"
              style={{ color: theme.text }}
            >
              {I18n.lets_create_account}
            </h1>
            <p className="fontSize14 fontWeight400 marBot0 darkGrayTwo">
              {I18n.signing_oscar_is_fast}
            </p>
          </div>

          <TextField
            onChange={onChange}
            label={I18n.enter_username}
            placeholder={I18n.enter_username}
            value={username}
            error={errors.username}
          />

          <TextField
            onChange={onChange}
            label={I18n.create_password}
            placeholder={I18n.create_password}
            value={password}
            type={viewPassword ? "text" : "password"}
            OnTextChangeType={"password"}
            error={errors.password}
            suffix={viewPassword ? "showEyeNewIcon" : "hideEyeNewIcon"}
            suffix_fill={theme.white}
            suffix_width={"18"}
            suffix_height={"18"}
            suffix_viewBox={"0 0 18 18"}
            suffixClick={() => setViewPassword((prev) => !prev)}
          />
          {/* 
          <TextField
            onChange={onChange}
            label={I18n.confirm_password}
            placeholder={I18n.confirm_password}
            value={confirmPassword}
            type={viewConfirmPassword ? "text" : "password"}
            OnTextChangeType={"confirm_password"}
            error={errors.confirmPassword}
            suffix="eyeIcon"
            suffix_fill={"blackFont"}
            suffix_width={"22"}
            suffix_height={"16"}
            suffix_viewBox={"0 0 22 16"}
            suffixClick={() => setViewConfirmPassword((prev) => !prev)}
          /> */}

          <TextField
            onChange={onChange}
            label={I18n.create_pin_code}
            placeholder={I18n.create_pin_code}
            value={pin}
            // type={viewPassword ? "text" : "password"}
            type="numeric"
            error={errors.pin}
            maxLength={4}
          />

          <div className="signupBottomText">
            <CheckBox
              checkboxLabel={
                <p className="marBot0 fontSize14" style={{ color: theme.text }}>
                  I agree Oscar’s
                  <a
                    style={{
                      textDecoration: "underline",
                      color: theme.text,
                      textUnderlineOffset: "3px",
                    }}
                    href=""
                  >
                    {" Terms, "}
                  </a>
                  <a
                    style={{
                      textDecoration: "underline",
                      color: theme.text,
                      textUnderlineOffset: "3px",
                    }}
                    href=""
                  >
                    {"privacy"}
                  </a>
                  {" and "}
                  <a
                    style={{
                      textDecoration: "underline",
                      color: theme.text,
                      textUnderlineOffset: "3px",
                    }}
                    href=""
                  >
                    policy
                  </a>
                </p>
              }
              onChange={toggleCheckBox}
              checked={isChecked}
            />
          </div>

          <div className="signinLoginButton">
            <Button
              className={`width100 fontWeight600 fontSize16 cursorPointer`}
              title={I18n.continue}
              handleClick={handleNext}
            />
          </div>
          <div>
            <p className="fontSize14 marTop0">
              <span className="white">{I18n.already_have_an_account}</span>

              <span
                className="cursorPointer  marLeft5 barclaysBlueColor"
                onClick={() => navigate("/login")}
              >
                {I18n.login}
              </span>
              <span className="marLeft5">
                <Icon name="arrowRight" viewBox="0 0 18 18 " />
              </span>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
};

export default Step2;
